"use client";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="cs">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#0F172A",
          color: "#FFFFFF",
          fontFamily: "system-ui, sans-serif",
          padding: "24px",
        }}
      >
        <div
          style={{
            maxWidth: "560px",
            width: "100%",
            border: "1px solid rgba(255,255,255,0.18)",
            padding: "48px",
          }}
        >
          <p
            style={{
              margin: 0,
              fontSize: "11px",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "#94A3B8",
            }}
          >
            NEOČEKÁVANÁ CHYBA
          </p>
          <h1
            style={{
              margin: "16px 0 0",
              fontSize: "2rem",
              lineHeight: 1.04,
              letterSpacing: "-0.02em",
            }}
          >
            Něco se pokazilo.
          </h1>
          <p style={{ marginTop: "24px", color: "#94A3B8" }}>
            Zkuste stránku načíst znovu. Pokud problém přetrvá, ozvěte se nám.
          </p>
          <button
            type="button"
            onClick={reset}
            style={{
              marginTop: "40px",
              minHeight: "52px",
              padding: "0 32px",
              backgroundColor: "#FFFFFF",
              color: "#111111",
              border: "none",
              fontSize: "12px",
              fontWeight: 700,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              cursor: "pointer",
            }}
          >
            Zkusit znovu
          </button>
        </div>
      </body>
    </html>
  );
}
